/**
 * @enum {string}
 */
import { StreamType } from '../../../api/models/Shared.types';
import {
  IChannelV5,
  IProgramSummary,
  IProperty,
  IScheduleSummary,
  ISeasonSummary,
  ISeriesSummary,
  IStreamAssetResponseV2,
} from '../../../api/models/AndromeTV.types';
import { Recording } from '../../../api/user/RecordingApi.types';
import { Bookmark } from '../logicHandlers/Bookmark';
import { addProperty } from '../../../api/analytics/AnalyticsUtil';
import { PropertyKeys } from '../../../api/analytics/ClientEvents';
import { Log } from '@lightningjs/sdk';

export const StreamInfoType = {
  VOD: 'VOD',
  LINEAR: 'LINEAR',
  REPLAY: 'REPLAY',
  NPVR: 'NPVR',
};

/**
 * @enum {number}
 */
export const StartPositionType = {
  START: 1,
  BOOKMARK: 2,
  LIVE: 3,
};

/**
 * @typedef {Object} EpgEvent
 * @property {IChannelV5} channel
 * @property {IProgramSummary} program
 * @property {ISeriesSummary} [series]
 * @property {IScheduleSummary} schedule
 * @property {Recording} [recording]
 */
export interface EpgEvent {
  season?: ISeasonSummary;
  channel: IChannelV5;
  program?: IProgramSummary;
  series?: ISeriesSummary;
  schedule?: IScheduleSummary;
  recording?: Recording;
}

export class StreamInfo {
  public currentAsset?: IStreamAssetResponseV2;
  public bookmark?: Bookmark;

  get isAdult(): boolean | undefined {
    return undefined;
  }

  get assetId(): string | undefined {
    return undefined;
  }

  get resourceId(): string | undefined {
    return undefined;
  }

  get type(): string | undefined {
    return undefined;
  }

  get vodStreamId(): string | undefined {
    return undefined;
  }

  get titleText(): string {
    return '';
  }

  get metaInfo(): string {
    return '';
  }

  get channelName(): string {
    return '';
  }

  /**
   * @returns {string}
   */
  get streamType(): StreamType | undefined {
    return undefined;
  }

  get quoteId(): string | undefined {
    return undefined;
  }

  get startPositionTime(): number | undefined {
    return 0;
  }

  get startOffset(): number {
    return 0;
  }

  get allowSeek(): boolean {
    return true;
  }

  get resumeFromLive(): boolean {
    return false;
  }

  get channel(): IChannelV5 | undefined {
    return undefined;
  }

  get schedule(): IScheduleSummary | undefined {
    return undefined;
  }

  get episode(): number | undefined {
    return 0;
  }

  get season(): number | undefined {
    return 0;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  convertPlayTimes(pos: number, duration: number, isLive = false): PlayerTimes {
    return {
      position: pos,
      duration: duration,
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
  updateBookmark(position: number, duration: number): boolean {
    return true;
  }

  generateAnalyticsProperties(excluded: string[]): IProperty[] {
    const properties: IProperty[] = [];
    addProperty(PropertyKeys.id, this.assetId, excluded, properties);
    addProperty(PropertyKeys.name, this.titleText, excluded, properties);
    addProperty(PropertyKeys.vodStreamId, this.vodStreamId, excluded, properties);
    addProperty(PropertyKeys.streamType, this.streamType, excluded, properties);
    addProperty(PropertyKeys.episode, this.episode, excluded, properties);
    addProperty(PropertyKeys.season, this.season, excluded, properties);
    return properties;
  }

  updateStartPositionType(type: number) {
    Log.warn(`Cannot update start position type ${type} for stream type ${this.type}`);
  }
}

export interface PlayerTimes {
  position: number;
  duration: number;
}
